// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-request.scss';

// utils
import foundation from '../_utils/foundation';
import Ease from '../_utils/Ease';
foundation();

document.addEventListener('DOMContentLoaded', () => {
	const $fv = document.querySelector('.js-fv');
	if ($fv) {
		const $headline = $fv.querySelector('.js-fv-headline');
		const $headlineEn = $headline.querySelector('.js-fv-headline-en');
		const $headlineJa = $headline.querySelector('.js-fv-headline-ja');
		const $enChar = $headlineEn.querySelectorAll('.char');

		function fvAnimation() {
			gsap.set($headline, {
				opacity: 1,
			});

			gsap.fromTo(
				$enChar,
				{
					display: 'inline-block',
					yPercent: 101,
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					stagger: 0.032,
				}
			);

			gsap.fromTo(
				$headlineJa,
				{
					yPercent: 101,
					display: 'inline-block',
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					delay: 0.4,
				}
			);
		}

		setTimeout(() => {
			fvAnimation();
		}, 400);
	}

	// メールアドレス（確認）
	function escapeHtml(text) {
		const map = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#039;',
			'\n': '<br/>',
		};

		return text.replace(/[&<>"'\n]/g, function (m) {
			return map[m];
		});
	}

	const email = document.getElementById('js-form-email');
	/**
	 * @type {HTMLInputElement} emailInput
	 */
	const emailInput = email.querySelector('input');
	const emailCheck = email.querySelector('.js-email-check');

	emailInput.addEventListener('input', () => {
		if (emailInput.value) {
			emailCheck.textContent = escapeHtml(emailInput.value);
		} else {
			emailCheck.textContent = 'sample@kinokuni-j.co.jp';
		}
	});

	document.addEventListener(
		'wpcf7mailsent',
		function () {
			setTimeout(() => {
				location.href = '../entry-thanks/';
			}, 1000);
		},
		false
	);

	// プレースホルダー非表示
	const textarea = document.querySelector('.js-textarea');
	const placeholder = document.querySelector('.js-placeholder');

	if (textarea && placeholder && placeholder instanceof HTMLElement) {
		// テキストエリアがHTMLTextAreaElementであることを確認
		if (textarea instanceof HTMLTextAreaElement) {
			textarea.addEventListener('input', () => {
				if (textarea.value.trim() === '') {
					// テキストエリアが空の場合、プレースホルダーを表示
					placeholder.style.display = 'block';
				} else {
					// テキストが入力された場合、プレースホルダーを非表示
					placeholder.style.display = 'none';
				}
			});
		}
	}

	// リダイレクト
	document.addEventListener(
		'wpcf7mailsent',
		function () {
			setTimeout(() => {
				location.href = '../request-thanks/';
			}, 1000);
		},
		false
	);
});

window.addEventListener('load', () => {});
